import { layoutOptimizationSchema, getLayoutOptimizationsResponseSchema, createLayoutOptimizationResponseSchema, getLayoutOptimizationFilesResponseSchema, getLayoutOptimizationResultsResponseSchema, layoutOptimizationResultSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const layoutOptimizationApiEndpoints = (builder, coreApiBaseUrl) => ({
    getLayoutOptimization: builder.query({
        query: ({ projectId, layoutId }) => `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/`,
        providesTags: ['LayoutOptimization'],
        transformResponse: createTransformer(layoutOptimizationSchema, 'getLayoutOptimization'),
    }),
    getLayoutOptimizationFiles: builder.query({
        query: ({ projectId, layoutId, page, pageSize, search }) => {
            const params = createParams({ page, pageSize, search });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/files/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['LayoutOptimizationFiles'],
        transformResponse: createTransformer(getLayoutOptimizationFilesResponseSchema, 'getLayoutOptimization'),
    }),
    getLayoutOptimizations: builder.query({
        query: ({ projectId, type }) => {
            const params = createParams({ type });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['LayoutOptimization'],
        transformResponse: createTransformer(getLayoutOptimizationsResponseSchema, 'getLayoutOptimization'),
    }),
    createLayoutOptimization: builder.mutation({
        query: ({ projectId, payload }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/`,
            method: 'POST',
            body: mapToSnakeCase(payload),
        }),
        invalidatesTags: ['LayoutOptimization', 'Projects'],
        transformResponse: createTransformer(createLayoutOptimizationResponseSchema, 'CreateLayoutOptimization'),
    }),
    updateLayoutOptimization: builder.mutation({
        query: ({ projectId, layoutOptimizationId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutOptimizationId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['LayoutOptimization'],
        transformResponse: createTransformer(layoutOptimizationSchema, 'UpdateLayoutOptimization'),
    }),
    deleteLayoutOptimization: builder.mutation({
        query: ({ projectId, layoutOptimizationId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutOptimizationId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['LayoutOptimization'],
    }),
    createLayoutOptimizationResult: builder.mutation({
        query: ({ projectId, layoutId, layoutResult }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/`,
            method: 'POST',
            body: mapToSnakeCase(layoutResult),
        }),
        invalidatesTags: ['LayoutOptimizationResults'],
        transformResponse: createTransformer(layoutOptimizationResultSchema, 'createLayoutOptimizationResult'),
    }),
    getLayoutOptimizationResults: builder.query({
        query: ({ projectId, layoutId, page, pageSize, search }) => {
            const params = createParams({ page, pageSize, search });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['LayoutOptimizationResults'],
        transformResponse: createTransformer(getLayoutOptimizationResultsResponseSchema, 'getLayoutOptimizationResults'),
    }),
    getLayoutOptimizationResult: builder.query({
        query: ({ projectId, layoutId, resultId }) => `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/${resultId}/`,
        providesTags: ['LayoutOptimizationResults'],
        transformResponse: createTransformer(layoutOptimizationResultSchema, 'getLayoutOptimizationResults'),
    }),
    updateLayoutOptimizationResult: builder.mutation({
        query: ({ projectId, layoutId, resultId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/${resultId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['LayoutOptimizationResults'],
        transformResponse: createTransformer(layoutOptimizationResultSchema, 'updateLayoutOptimizationResult'),
    }),
    deleteLayoutResult: builder.mutation({
        query: ({ projectId, layoutId, resultId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/${resultId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['LayoutOptimizationResults'],
    }),
    convertLayoutResultToPdf: builder.mutation({
        query: ({ projectId, layoutId, resultId, htmlContent }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/results/${resultId}/convert-to-pdf/`,
            method: 'POST',
            body: { html_content: htmlContent },
        }),
        invalidatesTags: ['LayoutOptimizationResults', 'Files'],
    }),
    deleteLayoutFile: builder.mutation({
        query: ({ projectId, layoutId, fileId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/files/${fileId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['LayoutOptimizationFiles'],
    }),
    addLayoutFiles: builder.mutation({
        query: ({ projectId, layoutId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/`,
            method: 'PATCH',
            body: data,
        }),
        invalidatesTags: ['LayoutOptimizationFiles'],
    }),
});
